import { createContext, Dispatch, ReactNode, useContext } from 'react';
import { FilterAction } from '../hook/useCommunityFilter';

export const CommunityFilterDispatchContext =
  createContext<Dispatch<FilterAction> | null>(null);

type CommunityFilterDispatchProviderProps = {
  filterDispatch: Dispatch<FilterAction>;
  children: ReactNode;
};

export const CommunityFilterDispatchProvider = ({
  filterDispatch,
  children,
}: CommunityFilterDispatchProviderProps) => {
  return (
    <CommunityFilterDispatchContext.Provider value={filterDispatch}>
      {children}
    </CommunityFilterDispatchContext.Provider>
  );
};

export const useCommunityFilterDispatch = (): Dispatch<FilterAction> => {
  const communityFilterDispatch = useContext(CommunityFilterDispatchContext);
  if (communityFilterDispatch == null) {
    throw Error('CommunityFilterDispatch is not in the context');
  }
  return communityFilterDispatch;
};
